import React, { FC, useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { Modal } from '@/components/modal';
import { Button } from '@/components/ui/button';
import { ModalProps } from '@/hooks/use-modal';
import { SupportModal } from '@/modules/common/components/modals/support-modal';

import { IntegrationServices } from '../../../../common/types/integrations';

const REASON_KEYS = ['credentials', 'permissions', 'reconnect', 'support'] as const;

interface ReasonsModalProps extends ModalProps {
  service: IntegrationServices;
}

export const ReasonsModal: FC<ReasonsModalProps> = ({ service, ...props }) => {
  const { t } = useTranslation(['authenticated.onboarding.integrations']);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  const handleSupportClick = () => {
    props.onClose();
    setIsSupportModalOpen(true);
  };

  return (
    <>
      <Modal className="max-w-lg" {...props}>
        <Modal.Title>{t('modals.reasons.title')}</Modal.Title>

        <Modal.Body>
          <ul className="list-inside space-y-4 text-sm">
            {REASON_KEYS.map((reasonKey, index) => (
              <li key={reasonKey}>
                <p className="font-medium">
                  {index + 1}. {t(`modals.reasons.items.${reasonKey}.title`)}
                </p>
                <p className="text-muted-foreground">
                  <Trans
                    t={t}
                    i18nKey={`modals.reasons.items.${reasonKey}.description`}
                    components={{
                      supportLink: (
                        <button
                          type="button"
                          className="text-foreground underline"
                          onClick={handleSupportClick}
                        />
                      ),
                    }}
                  />
                </p>
              </li>
            ))}
          </ul>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={props.onClose}>{t('actions.close')}</Button>
        </Modal.Footer>
      </Modal>

      <SupportModal open={isSupportModalOpen} onOpenChange={setIsSupportModalOpen} />
    </>
  );
};
